import { Component } from '@angular/core';
import { Data } from '../types/teams.type';
import { TeamsService } from '../../../shared/services/teams.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidateFormService } from '../../../shared/services/validate-form.service';
import { ToastrService } from 'ngx-toastr';
import { positiveNumberValidator } from '../../../shared/validators/positive-number.validator';

@Component({
  selector: 'app-create-team',
  templateUrl: './create-team.component.html',
  styleUrl: './create-team.component.scss',
})
export class CreateTeamComponent {
  colors = [
    { name: 'أحمر', hexCode: '#FF0000' }, // Red
    { name: 'أخضر', hexCode: '#008000' }, // Green
    { name: 'أزرق', hexCode: '#0000FF' }, // Blue
    { name: 'أصفر', hexCode: '#FFFF00' }, // Yellow
    { name: 'برتقالي', hexCode: '#FFA500' }, // Orange
    { name: 'أرجواني', hexCode: '#800080' }, // Purple
    { name: 'وردي', hexCode: '#FFC0CB' }, // Pink
    { name: 'بني', hexCode: '#A52A2A' }, // Brown
    { name: 'أسود', hexCode: '#000000' }, // Black
    { name: 'أبيض', hexCode: '#FFFFFF' }, // White
    { name: 'رمادي', hexCode: '#808080' }, // Gray
    { name: 'سماوي', hexCode: '#87CEEB' }, // Sky Blue
    { name: 'ذهبي', hexCode: '#FFD700' }, // Gold
    { name: 'فضي', hexCode: '#C0C0C0' }, // Silver
    { name: 'كستنائي', hexCode: '#800000' }, // Maroon
    { name: 'فيروزي', hexCode: '#40E0D0' }, // Turquoise
    { name: 'ليموني', hexCode: '#32CD32' }, // Lime
    { name: 'نيلي', hexCode: '#4B0082' }, // Indigo
    { name: 'زهري', hexCode: '#FF69B4' }, // Hot Pink
    { name: 'خزامى', hexCode: '#E6E6FA' }, // Lavender
  ];

  teams: Data[] = [];
  public createTeamFrom: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    color: new FormControl('', [Validators.required]),
    playersNo: new FormControl('', [
      Validators.required,
      Validators.pattern('^[0-9]*$'),
    ]),
    points: new FormControl('0', [Validators.required]),
  });
  constructor(
    private _teams: TeamsService,
    private validateForm: ValidateFormService,
    private toaster: ToastrService
  ) {}

  ngOnInit() {
    this.getTeams();
  }

  getTeams() {
    this._teams.getTeams().subscribe({
      next: (response) => {
        this.teams = response.data;
      },
      error: (error) => {
        console.log('Error: ', error);
      },
    });
  }
  createTeam() {
    if (this.createTeamFrom.invalid) {
      console.log(this.createTeamFrom);
      return this.validateForm.validateAllFormFields(this.createTeamFrom);
    }
    const sentData = { ...this.createTeamFrom.value };
    sentData.points = parseInt(sentData.points);
    this._teams.createTeam(sentData).subscribe({
      next: (response) => {
        if (response.message == 'Team with this name already exists') {
          this.toaster.error('فريق بنفس الاسم موجود بالفعل');
        } else {
          this.createTeamFrom.reset();
          this.getTeams();
          this.toaster.success('تم إنشاء الفريق بنجاح');
        }
      },
      error: (error) => {
        console.log('Error: ', error);
      },
    });
  }
}
